<template>

    <div class="vx-row">
        <div class="vx-col w-2/3">
            <vs-card>
                <vs-input v-model="name" class="w-full" placeholder="Naam"></vs-input>
            </vs-card>
            <vs-card class="mb-4">
                <div slot="header">
                    <h5>Beschrijving</h5>
                </div>
                <div>
                    <vs-textarea v-model="description" height="250px"></vs-textarea>
                </div>
            </vs-card>
        </div>
        <div class="vx-col w-1/3">
            <vs-card class="mb-4">
                <div slot="header">
                    <h5>Sla categorie op!</h5>
                </div>
                <div>
                    <vs-checkbox v-model="multiple" :vs-value="true">Meerdere opties mogelijk?</vs-checkbox>
                    <vs-input v-model="position" class="w-full mb-4" placeholder="Positie"></vs-input>
                    <vs-button @click="createCategory">Opslaan</vs-button>
                </div>
            </vs-card>
        </div>
    </div>

</template>

<script>
export default {
    data() {
        return {
            position: '',
            description: '',
            multiple: false,
            name: ''
        }
    },
    created() {},
    computed: {
        staffRoute () {
            if(this.$route.meta.staff) {
                if(localStorage.getItem('stafftoken') !== null) {
                    return true
                }
            } else {
                if(localStorage.getItem('stafftoken') !== null) {
                    return true
                }
                return false
            }
        },
    },
    methods: {
        createCategory: function() {
            let formData = new FormData();

            formData.append('name', this.name);
            formData.append('position', this.position);
            formData.append('description', this.description);
            formData.append('multiple', this.multiple == true ? 1 : 0);

            let token = this.staffRoute ? JSON.parse(localStorage.getItem('stafftoken')) : JSON.parse(localStorage.getItem('companytoken'));
            let url = this.staffRoute ? 'https://staffapi.hebtrek.nl/v1/company/'+ this.$route.params.slug +'/addon-category/create' : 'https://companyapi.hebtrek.nl/v1/company/'+ this.$route.params.slug +'/addon-category/create'
            this.$http.post(url, formData,
            {
                headers: {
                    Authorization: 'Bearer ' + token,
                    'Content-Type': 'multipart/form-data'
                }
            }).then((response) => {
                console.log(response)
                this.$router.push({'name': 'companies-products-option-categories'});
                this.$vs.notify({
                    title: 'Success',
                    text: 'Succesvol opgeslagen',
                    color: 'success'
                });
            }).catch((error) => {
                this.$util.logError(error, this.$vs);
            })
        }
    }
}
</script>

<style>

</style>
